import React from "react";
import O2log from "./components/o2cz_logistics";

export default class O2API extends React.Component {
  state = {
    selectGroup: 0,
    editorState: null,
    groups: [
      {
        title: "O2-CZ Logistics",
        key: 0
      },
      {
        title: "O2-CZ Finance",
        key: 1
      }
    ]
  };

  componentDidMount() {
    const {Icon} = this.props;
    this.props.setHeaderPage({
      Icon: <Icon facodebranch className="c-placeholder c-green" />,
      Title: "O2 Integrace",
      SubTitle: "Kompletní integrace s O2 CZ",
    });
  }

  render() {
    const { Bs, VARIANT } = this.props;
    return (
      <>
        <Bs row className="mb-4">
          <Bs
            nav
            variant={VARIANT.TABS}
            className="c-tab"
            defaultActiveKey={this.state.selectGroup}
          >
            {this.state.groups.map(e => (
              <Bs navitem>
                <Bs
                  navlink
                  onClick={() => this.setState({ selectGroup: e.key })}
                  eventKey={e.key}
                >
                  {e.title}
                </Bs>
              </Bs>
            ))}
          </Bs>
        </Bs>
        {this.state.selectGroup === 0 && (<O2log {...this.props} />)}
      </>
    );
  }
}
